module.exports = __webpack_public_path__ + "img/sassi_0.1a041b8a.jpg";